import React, { useState, useMemo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from 'react-router-dom';
import {
    Container,
    Button,
    Col,
    Row,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    getAssetCategoryById as onGetAssetCategory,
    updateAssetCategory as onUpdateAssetCategory,
    addAssetCategory as onAddAssetCategory,
    getCompanies as onGetCompanies
} from "../../store/actions";

import * as Yup from "yup";
import { useFormik } from "formik";

import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";

const AssetCategoryCreateUpdate = (props) => {

    //meta title
    document.title = "Asset Category | Master Data | Des Counts";
    const id = props?.match?.params?.id;
    const companyId = props?.match?.params?.companyId;
    const isEdit = id != undefined && companyId != undefined;

    const { companies, assetCategory, loading, error } = useSelector(state => ({
        companies: state.Company.companies,
        assetCategory: state.AssetCategory.assetCategory,
        loading: state.AssetCategory.loading,
        error: state.AssetCategory.error,
    }));

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e)
        validation.setFieldValue("companyId", e.value.toString(), true)
    }

    const dispatch = useDispatch();
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: isEdit && assetCategory ? assetCategory.companyId : "",
            name: isEdit && assetCategory ? assetCategory.name : "",
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Please Select company"),
            name: Yup.string().required("Please Enter Category Name"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                dispatch(onUpdateAssetCategory({ id: assetCategory.id, companyId: assetCategory.companyId, name: values.name }, props.history));
            } else {
                dispatch(onAddAssetCategory({
                    name: values.name,
                    companyId: parseInt(values.companyId)
                }, props.history));
            }
        },
    });


    useEffect(() => {
        dispatch(onGetCompanies({}))
        if (isEdit) {
            dispatch(onGetAssetCategory(id, companyId))
        }
    }, [dispatch])

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (isEdit && assetCategory && companies) {
            var company = optionCompany.filter(s => s.value == assetCategory.companyId)
            if (company.length > 0) {
                setSelectedCompany(company[0])
            }
        }
    }, [optionCompany, assetCategory])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Master Data" breadcrumbItem={(isEdit ? "Edit" : "Add") + " Asset Category"} />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    {
                                        !loading &&
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form
                                                        className="form-horizontal"
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col className="col-12 col-sm-6">
                                                                <div className="mb-3">
                                                                    <Label>Company</Label>
                                                                    <div
                                                                        style={validation.errors.companyId ? { border: '1px solid #f46a6a', borderRadius: '0.25rem' } :
                                                                            { border: '0', borderRadius: '0.25rem' }}
                                                                    >
                                                                        <Select
                                                                            value={selectedCompany}
                                                                            onChange={handleSelectCompany}
                                                                            onBlur={validation.handleBlur}
                                                                            options={optionCompany}
                                                                            isDisabled={isEdit}
                                                                            className="select2-selection"
                                                                            menuPosition="fixed"
                                                                        />
                                                                    </div>
                                                                    {validation.touched.companyId && validation.errors.companyId ? (
                                                                        <FormFeedback className="d-block" type="invalid">{validation.errors.companyId}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 col-sm-6">
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Name</Label>
                                                                    <Input
                                                                        name="name"
                                                                        className="form-control"
                                                                        placeholder="Enter category name"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.name || ""}
                                                                        invalid={
                                                                            validation.touched.name && validation.errors.name ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.name && validation.errors.name ? (
                                                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>


                                                        <div className="mt-3 mb-2">
                                                            <Link to="/masterdata/asset-category">
                                                                <Button
                                                                    color="secondary"
                                                                    className="btn btn-secondary float-end"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Link>
                                                            <Button
                                                                color="primary"
                                                                className="btn btn-primary float-end me-2"
                                                                type="submit"
                                                            >
                                                                Submit
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loading &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

AssetCategoryCreateUpdate.propTypes = {
    history: PropTypes.object,
};

export default withRouter(AssetCategoryCreateUpdate)
